import { TypePolicies } from '@apollo/client';
import { offsetLimitPagination } from '@apollo/client/utilities';
import { ILogger } from '@bloomays-lib/types.shared';
import { ApolloClientConfig, createApolloErrorFilter } from '@bloomays-lib/common.auth/browser';
const { VITE_BLOOMERS_API, VITE_TALENTS_API } = import.meta.env;

export const filterExceptions = createApolloErrorFilter({
  businessCodesToIgnore: ['TOKEN_EXPIRED', 'UNKNOWN_BLOOMER'],
});

// Type policies spécifiques à form.bloomers
export const typePolicies: TypePolicies = {
  LegalContract: { keyFields: ['recordId'] },
  NPSScoring: { keyFields: ['recordId'] },
  Bloomer: { keyFields: ['recordId'], merge: true },
  Notification: { keyFields: ['recordId'], merge: true },
  Mission: { keyFields: ['recordId'] },
  Acivity: { keyFields: ['recordId'] },
  Invitation: { keyFields: ['recordId'] },
  Society: { keyFields: ['recordId'] },
  Contact: { keyFields: ['recordId'] },
  Pricing: { keyFields: ['recordId'] },
  Billing: { keyFields: ['recordId'] },
  GqlJobFunnel: { keyFields: ['id'] },
  Query: {
    fields: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      allMissions: { missions: offsetLimitPagination(['isActive']) },
      me: {
        // https://www.apollographql.com/docs/react/caching/cache-field-behavior/#merging-non-normalized-objects
        merge: true,
      },
    },
  },
};

export const getApolloConfig = (logger: ILogger): ApolloClientConfig => {
  return {
    apiUrls: {
      bloomers: VITE_BLOOMERS_API,
      talents: VITE_TALENTS_API,
    },
    logger,
    typePolicies,
    filterExceptions,
  };
};
